import { login, logout, getInfo, getRbacMe } from '@/api/user'
import { getToken, setToken, removeToken, setOpenId, removeOpenId, getOpenId, setUserName, setUserNickName } from '@/utils/auth'
import { resetRouter } from '@/router'
import { parseRoles } from '@/utils/roles'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    // openid: '',
    openid: getOpenId(),
    roles: [],
    uid: getOpenId(),
    role: '',
    systemAdmin: false,
    groupUid: '',
    ownerUid: null,
    permissions: [],
    orgUid: '',
    dataScope: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_OPENID: (state, openid) => {
    state.openid = openid
  },
  SET_UID: (state, uid) => {
    state.uid = uid
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_SYSTEM_ADMIN: (state, systemAdmin) => {
    state.systemAdmin = systemAdmin
  },
  SET_GROUP_UID: (state, groupUid) => {
    state.groupUid = groupUid
  },
  SET_OWNER_UID: (state, ownerUid) => {
    state.ownerUid = ownerUid
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions || []
  },
  SET_ORG_UID: (state, orgUid) => {
    state.orgUid = orgUid || ''
  },
  SET_DATA_SCOPE: (state, dataScope) => {
    state.dataScope = dataScope || ''
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, code, mobile, countryCode, type } = userInfo
    // 国际号码：区号+手机号拼接（如 861391234567），去掉+避免后端解析问题
    const fullPhone = countryCode ? countryCode.replace(/^\+/, '') + mobile : mobile
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password, code: code, mobile: fullPhone, type: type })
        .then(response => {
          const { data } = response
          const uid = data.uid || data.openid
          commit('SET_TOKEN', data.token)
          commit('SET_OPENID', uid)
          commit('SET_UID', uid)
          commit('SET_ROLE', data.role || '')
          commit('SET_SYSTEM_ADMIN', !!data.systemAdmin)
          commit('SET_GROUP_UID', data.groupUid || '')
          commit('SET_OWNER_UID', data.ownerUid || null)
          commit('SET_ROLES', parseRoles(data.roles))
          commit('SET_NAME', data.login_name)
          console.log(data)
          setToken(data.token)
          setOpenId(uid)
          setUserName(data.login_name)
          setUserNickName(data.nickName)
          getRbacMe().then(rbacResponse => {
            const rbac = rbacResponse.data || {}
            commit('SET_ROLES', parseRoles(rbac.roles))
            commit('SET_PERMISSIONS', rbac.permissions)
            commit('SET_ORG_UID', rbac.orgUid)
            commit('SET_DATA_SCOPE', rbac.dataScope)
            resolve()
          }).catch(error => {
            if (process.env.VUE_APP_RBAC_ENABLED === 'true') {
              removeToken()
              removeOpenId()
              commit('RESET_STATE')
              reject(error)
              return
            }
            resolve()
          })
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.openid)
        .then(response => {
          const { data } = response

          if (!data) {
            reject('Verification failed, please Login again.')
          }

          const { roles, name, avatar } = data
          const parsedRoles = parseRoles(roles)

          // roles must be a non-empty array
          if (!parsedRoles || parsedRoles.length <= 0) {
            reject('getInfo: roles must be a non-null array!')
            return
          }

          commit('SET_ROLES', parsedRoles)
          commit('SET_OPENID', data.uid || data.openid || state.openid)
          commit('SET_UID', data.uid || data.openid || state.uid)
          commit('SET_ROLE', data.role || '')
          commit('SET_SYSTEM_ADMIN', !!data.systemAdmin)
          commit('SET_GROUP_UID', data.groupUid || '')
          commit('SET_OWNER_UID', data.ownerUid || null)
          commit('SET_NAME', data.login_name || data.nickName || name)
          commit('SET_AVATAR', avatar)
          getRbacMe().then(rbacResponse => {
            const rbac = rbacResponse.data || {}
            const effectiveRoles = parseRoles(rbac.roles)
            commit('SET_ROLES', effectiveRoles)
            commit('SET_PERMISSIONS', rbac.permissions)
            commit('SET_ORG_UID', rbac.orgUid)
            commit('SET_DATA_SCOPE', rbac.dataScope)
            resolve({ ...data, roles: effectiveRoles })
          }).catch(error => {
            if (process.env.VUE_APP_RBAC_ENABLED === 'true') {
              reject(error)
              return
            }
            resolve(data)
          })
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          removeToken() // must remove  token  first
          removeOpenId()
          resetRouter()
          commit('RESET_STATE')
          resolve()
        })
        .catch(error => {
          removeOpenId()
          reject(error)
        })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
